// All values are PDF points at scale 1, the LegendBox convention; they are multiplied by the page scale.
export const NOTE_PAGE_MARGIN = 24;
export const NOTE_TITLE_FONT_SIZE = 16;
export const NOTE_PAGE_LABEL_FONT_SIZE = 10;
export const NOTE_HEADER_HEIGHT = 30;
export const NOTE_ENTRY_GAP = 14;

export const NOTE_CROP_SIDE = 132;
export const NOTE_CROP_CARD_GAP = 12;
export const NOTE_CROP_BORDER_WIDTH = 1;

export const NOTE_CARD_RADIUS = 8;
export const NOTE_CARD_FRAME_INSET = 4;
export const NOTE_CARD_HEADER_PAD_X = 10;
export const NOTE_CARD_HEADER_PAD_Y = 6;
export const NOTE_HEADER_LINE_GAP = 3;
export const NOTE_GROUP_FONT_SIZE = 11;
export const NOTE_BYLINE_FONT_SIZE = 9.5;
export const NOTE_BYLINE_OPACITY = 0.8;

export const NOTE_BODY_RADIUS = 6;
export const NOTE_BODY_PAD_X = 10;
export const NOTE_BODY_PAD_Y = 8;
export const NOTE_BODY_FONT_SIZE = 11;
export const NOTE_BODY_LINE_HEIGHT = 16;
// Long lines read badly on wide pages; the card still spans the row, the text does not.
export const NOTE_BODY_MAX_TEXT_WIDTH = 420;
// A note split over pages never leaves fewer lines than this on a page.
export const NOTE_MIN_LINES_PER_SEGMENT = 3;

// The crop shows this many bbox sides around the marker, within the region bounds.
export const NOTE_CROP_CONTEXT_FACTOR = 4;
export const NOTE_CROP_MIN_REGION_PT = 80;
export const NOTE_CROP_MAX_REGION_PT = 600;
export const NOTE_CROP_BBOX_FIT = 1.25;
// A low-resolution source widens the region instead of blurring the crop.
export const NOTE_CROP_MAX_UPSCALE = 2.5;
export const NOTE_CROP_BBOX_STROKE = 2;
export const NOTE_CROP_BBOX_FILL_OPACITY = 0.12;
export const NOTE_ATLAS_MAX_WIDTH = 4096;

// White text pages: 1.0 would cost several MB per page for no visible gain.
export const NOTE_PAGE_JPEG_QUALITY = 0.92;
export const NOTE_PAGE_BACKGROUND = "#FFFFFF";
export const NOTE_CROP_BORDER_COLOR = "#D1D5DB";
export const NOTE_PAGE_LABEL_COLOR = "#6B7280";
export const NOTE_OUTLINE_UNDER_STROKE_COLOR = "#FFFFFF";
